export const StandardLayout = ({title, content}) => {
    return(
        <div className="container">
            <h1 style={{ margin: '10px' }}>{title}</h1>
            <div className="innerContainer">
                {content}
            </div>
        </div>
    )
}